import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function SuperbuySpreadsheet() {
  return <ArticleLayout content={allArticles[6]} />;
}